import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EnhancedNavItemBlueprint } from '@ipen-portal/plugin-common-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { ipenEventsRef } from './apis';
import { rootRouteRef } from './routes';

export const homepagePlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'events-api',
      params: defineParams =>
        defineParams({
          apiRef: ipenEventsRef,
          path: 'ipen/events',
        }),
    }),
    PageBlueprint.make({
      name: 'IpenHomepage',
      params: {
        loader: () =>
          import('./components/Homepage/Homepage').then(m => <m.Homepage />),
        noHeader: true,
        path: '/home',
        routeRef: rootRouteRef,
      },
    }),
    EnhancedNavItemBlueprint.make({
      params: {
        icon: 'https://theme.ipen.eon.com/icons/navbar/home_boxed.svg',
        pageTheme: 'default',
        target: '/home',
        title: 'Home',
      },
    }),
  ],
  pluginId: 'homepage',
  routes: {
    root: rootRouteRef,
  },
});
